'use es6';

import { Component } from 'react';
import omit from '../utils/underscore/omit';
import UINumberInput from './UINumberInput';
import { jsx as _jsx } from "react/jsx-runtime";
class UIPercentageInput extends Component {
  render() {
    return /*#__PURE__*/_jsx(UINumberInput, Object.assign({}, this.props, {
      formatStyle: "percentage"
    }));
  }
}
UIPercentageInput.displayName = 'UIPercentageInput';
UIPercentageInput.propTypes = Object.assign({}, omit(UINumberInput.propTypes, ['formatStyle', 'currency']));
UIPercentageInput.defaultProps = Object.assign({}, UINumberInput.defaultProps);
export default UIPercentageInput;